const expertAnalyzeList = {
  height: 70,
  complexColumns: [
    {
      header: 'AI분석결과(MAX)',
      name: 'aiScoreMax',
      childNames: ['aiOwas', 'aiRula', 'aiReba'],
    },
    {
      header: '전문가분석결과(MAX)',
      name: 'exprtScoreMax',
      childNames: ['exprtOwas', 'exprtRula', 'exprtReba'],
    },
  ],
};

export default function getGridHeader(id) {
  switch (id) {
    case 'expertAnalyzeList':
      return expertAnalyzeList;
    default:
      return { height: 52 };
  }
}
